import { render, staticRenderFns } from "./RulesCard.vue?vue&type=template&id=1c123278&scoped=true"
import script from "./RulesCard.vue?vue&type=script&lang=js"
export * from "./RulesCard.vue?vue&type=script&lang=js"
import style0 from "./RulesCard.vue?vue&type=style&index=0&id=1c123278&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c123278",
  null
  
)

export default component.exports